import { render, staticRenderFns } from "./examPaperCard.vue?vue&type=template&id=d39200a6&scoped=true"
import script from "./examPaperCard.vue?vue&type=script&lang=js"
export * from "./examPaperCard.vue?vue&type=script&lang=js"
import style0 from "./examPaperCard.vue?vue&type=style&index=0&id=d39200a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39200a6",
  null
  
)

export default component.exports